import Screen from '../Screen';
import React, { FC, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import textAPI from "api/textAPI";
import { getTestKey } from "config/sources";
import { DEFAULT_TOEIC_YEAR } from "config/defaultYear";
import CryptoJS from 'crypto-js';
import Part2Item from './shared/Part2Item';
import Footer from 'components/Footer';
import { getPart } from 'store/selectors/selectors';
import { updatePartAction } from 'store/actionTypes/actionType';
import { useDispatch, useSelector } from 'react-redux';
import { TestFlatList } from 'components/TestFlatList';

const Part2: FC = () => {
  const [testList, setTestList] = useState<any[]>([]);
  const [correctNumber, setCorrectNumber] = useState<number>(-1);
  const [totalNumber, setTotalNumber] = useState<number>(-1);

  const history = useHistory();
  const dispatch = useDispatch();
  const { testNumber, year } = useParams();
  const testName = getTestKey(year, testNumber);
  const part  = useSelector(getPart(testName, 'part2'));
  useEffect(() => {
    getData(testNumber, part);
  }, []);

  const getData = async (testNumber: number, part: any) => {
    const cached: any[] = (part && part.questions && part.questions.length > 0) ? part.questions : [];
    try {
      const data = await textAPI.get(year, testNumber, 2);
      const plainData = CryptoJS.AES.decrypt(data, 'thieumao').toString(CryptoJS.enc.Utf8);
      const json = JSON.parse(plainData);
      const merged = json.map((item: any, i: number) => {
        const prev = cached[i];
        if (!prev) return item;
        return { ...item, selected: prev.selected, submitted: prev.submitted };
      });
      setTestList(merged);
      updateDatabase(testName, merged);
    } catch (err) {
      if (cached.length > 0) setTestList(cached);
      else throw err;
    }
  };

  const updateDatabase = async (testName: string, partQuestions: any[]) => {
    const partDetail = {
      name: 'Part 2',
      questions: partQuestions,
    };
    dispatch(updatePartAction(testName, 'part2', partDetail));
  };

  const selectAnswer = (item: any, index: number, selected: string) => {
    let arr = testList || [];
    if (arr[index].selected != selected) {
      arr[index].selected = selected;
    } else {
      arr[index].selected = undefined;
    }
    updateDatabase(testName, arr);
  };

  const onReset = () => {
    let arr = testList || [];
    for (let item of arr) {
      item.submitted = false;
      item.selected = undefined;
    }
    updateDatabase(testName, arr);

    setCorrectNumber(-1);
  };

  const onSubmit = () => {
    calculateScore();
    let arr = testList || [];
    for (let item of arr) {
      if (item.selected) {
        item.submitted = true;
      }
    }
    updateDatabase(testName, arr);
  };

  const calculateScore = () => {
    let correctCount = 0;
    let count = 0;
    for (const item of testList) {
      count += 1;
      if (item.selected) {
        if (item.selected == item.correct) {
          // correct
          correctCount += 1;
        } else {
          // incorrect
        }
      } else {
        // not choose
      }
    }
    setCorrectNumber(correctCount);
    setTotalNumber(count);
  };

  const onOpenDetail = (item: any, index: number) => {
    history.push(`/toeic${year || DEFAULT_TOEIC_YEAR}/test${testNumber}/part2/question${index + 1}`);
  };

  const onOpenDetailFill = (item: any, index: number) => {
    history.push(`/toeic${year || DEFAULT_TOEIC_YEAR}/test${testNumber}/part2/question${index + 1}/fill`);
  };

  const renderItem = ({ index }: { item; index }) => {
    const item = testList[index];
    return (
      <Part2Item
        item={item}
        index={index}
        testNumber={testNumber}
        onClick={selectAnswer}
        onOpenDetail={onOpenDetail}
        onOpenDetailFill={onOpenDetailFill}
      />
    );
  };

  return (
      <Screen canBack title={`Test ${testNumber} - Part 2`} showMenu={false} isLoading={!testList.length}>
        <TestFlatList
          data={testList}
          renderItem={renderItem}
          keyExtractor={(item, index) => `${index}_${item}`}
        />
        <Footer correctNumber={correctNumber} totalNumber={totalNumber} onReset={onReset} onSubmit={onSubmit} />
      </Screen>
  );
};

export default Part2;
